import { render, staticRenderFns } from "./resourceEdit.vue?vue&type=template&id=19f9d1ca&scoped=true&"
import script from "./resourceEdit.vue?vue&type=script&lang=js&"
export * from "./resourceEdit.vue?vue&type=script&lang=js&"
import style0 from "./resourceEdit.vue?vue&type=style&index=0&id=19f9d1ca&scoped=true&lang=css&"
import style1 from "./resourceEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f9d1ca",
  null
  
)

export default component.exports